module.exports = __webpack_public_path__ + "9883521aecdf756e7f75c6c791a5d9bf.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/LY.svg
// module id = gmqB
// module chunks = 0